import React, { memo } from "react";
import TanStackTable from "../table/TanStackTable";

export const TableArea = memo(() => {
  return <TanStackTable />;
});
